// DEVAMS-2025: CASL has been removed from the application. This module is kept
// only because vendor scaffolding components in src/@layouts/components import
// these helpers. They are now no-ops — visibility for navigation items is
// driven by `checkVisibilityAllowed` in src/@layouts/components/VerticalNav.vue.
export const can = () => true

export const canViewNavMenuGroup = item =>
  Array.isArray(item.children) && item.children.length > 0
